var map = {
	"./ .png": "1007",
	"./404.png": "8f20",
	"./Android-market.png": "e91e",
	"./Android-qrCode.png": "c346",
	"./AndroidMarket.png": "d606",
	"./Apple-qrCode.png": "175d",
	"./Apple-store-2.png": "80d7",
	"./Apple-store.png": "9e5c",
	"./AppleStore.png": "8ceb",
	"./Google-play.png": "c98a",
	"./Google-qrCode.png": "477e",
	"./GooglePlay.png": "37a5",
	"./add.png": "1d89",
	"./address.png": "c542",
	"./aed.png": "31c5",
	"./andriod.png": "0222",
	"./apk-day.png": "7b09",
	"./appDownLoad.png": "c735",
	"./apple.png": "4977",
	"./arrow-down.png": "4c22",
	"./arrow-down_clear.png": "b6fe",
	"./avatar.png": "690a",
	"./brand/about-logo-dark.png": "8e66",
	"./brand/about-logo.png": "9a9c",
	"./brand/top-banner-dark.png": "20f2",
	"./brand/top-banner.png": "eb33",
	"./chat-wedget-white.png": "6580",
	"./chat-wedget.png": "40717",
	"./close.png": "04b3",
	"./contract-icon/cl.png": "e421",
	"./contract-icon/di.png": "5e60",
	"./contract-icon/em.png": "807a",
	"./contract-icon/fa.png": "7ef5",
	"./contract-icon/po.png": "7e8a",
	"./contract-icon/pop.png": "c1ac",
	"./contract-icon/re.png": "66d3",
	"./contract-icon/te.png": "3556",
	"./contract-icon/tw.png": "b4a6",
	"./contract-icon/wb.png": "780a",
	"./contract-icon/yo.png": "7e70",
	"./contract-icon/ze.png": "a45c",
	"./coop/banner-dark.png": "0409",
	"./coop/banner.png": "0a40",
	"./coop/reason/icon1.png": "a3cb",
	"./coop/reason/icon2.png": "c9d3",
	"./coop/reason/icon3.png": "7af5",
	"./coop/security/icon1.png": "da86",
	"./coop/security/icon2.png": "8094",
	"./coop/security/icon3.png": "1c70",
	"./coop/security/icon4.png": "42ea",
	"./coop/security/icon5.png": "c82d",
	"./coop/service/icon1.png": "f4c1",
	"./coop/service/icon2.png": "c3b8",
	"./coop/service/icon3.png": "aa06",
	"./coop/service/icon4.png": "d321",
	"./currency-switch.png": "fbf3",
	"./currency-value.png": "4c2b",
	"./customer-service.png": "c3d6",
	"./dot.png": "d29c",
	"./download-dark.png": "1aeb",
	"./download-light.png": "7f4a",
	"./en.png": "17b5",
	"./exchange/active.png": "3267",
	"./exchange/depth-1.png": "bdf2",
	"./exchange/depth-2.png": "54be",
	"./exchange/depth-3.png": "be06",
	"./exchange/noActive.png": "23ed",
	"./expression/expression-bad.png": "7f51",
	"./expression/expression-cool.png": "a7ea",
	"./expression/expression-great.png": "5dfa",
	"./fan.png": "0a6f",
	"./finances-bg-8coin.png": "51e2",
	"./finances-bg.png": "4179",
	"./finances/current-img-1.png": "c120",
	"./finances/current-img-2.png": "43bd",
	"./finances/current-img-3.png": "c2cc",
	"./financial-detail/1@3x.png": "125a",
	"./financial-detail/2@3x.png": "c61e",
	"./financial-detail/3@3x.png": "c009",
	"./financial-detail/icon-2@3x.png": "7dfe",
	"./financial-detail/icon-3@3x.png": "0733",
	"./financial-detail/tro-bg.png": "7910",
	"./full-screen.png": "2162",
	"./fund/img/arrowImg.png": "51f1",
	"./fund/img/banner_en.png": "da38",
	"./fund/img/banner_vi.png": "ca3b",
	"./fund/img/banner_zh.png": "1dcf",
	"./fund/img/bg.png": "2c61",
	"./fund/img/bg1.png": "622c",
	"./fund/img/bgBox_bg.png": "d485",
	"./fund/img/box3_img.png": "0381",
	"./fund/img/box4_bg.png": "4609",
	"./fund/img/btn.png": "4ec6",
	"./fund/img/copy-light.png": "d593",
	"./fund/img/copy.png": "1eb3",
	"./fund/img/footer_bg.png": "4c2b3",
	"./fund/img/footer_img1.png": "50a5",
	"./fund/img/footer_img2-light.png": "4412",
	"./fund/img/footer_img2.png": "7a4f",
	"./fund/img/hashIcon.png": "3223",
	"./fund/img/img1.png": "cd37",
	"./fund/img/img2.png": "4403",
	"./fund/img/imgBox_bg.png": "e44f",
	"./fund/img/imgBox_img.png": "a981",
	"./fund/img/leftImg.png": "5181",
	"./fund/img/light_bg.png": "5f69",
	"./fund/img/light_bgBox_bg.png": "3390",
	"./fund/img/light_btn.png": "8aac",
	"./fund/img/light_footer_bg.png": "77c4",
	"./fund/img/light_footer_img2.png": "5bf9",
	"./fund/img/light_img1.png": "b239",
	"./fund/img/light_img2.png": "8a92",
	"./fund/img/light_leftImg.png": "9935",
	"./fund/img/light_m_bg.png": "0d14",
	"./fund/img/light_m_bgBox_bg.png": "a3de2",
	"./fund/img/light_m_footer_bg.png": "bd05",
	"./fund/img/light_rightImg.png": "0c08",
	"./fund/img/link.png": "9c94",
	"./fund/img/m_bg.png": "3d13",
	"./fund/img/m_bgBox_bg.png": "f593",
	"./fund/img/m_box3_img.png": "dfb4",
	"./fund/img/m_btn.png": "d78f",
	"./fund/img/m_footer_bg.png": "2e76",
	"./fund/img/m_imgBox_bg.png": "8ca3",
	"./fund/img/m_imgBox_img.png": "8066",
	"./fund/img/mainBox_bg.png": "2829",
	"./fund/img/rightImg.png": "d219",
	"./gp-day.png": "04cd",
	"./holder-coin-ico.png": "896e",
	"./home/5-1.png": "c412",
	"./home/5-2.png": "ab05",
	"./home/5-3.png": "6b2c",
	"./home/about/dark/1.png": "7ac7",
	"./home/about/dark/2.png": "5d5e",
	"./home/about/dark/3.png": "bd8a",
	"./home/about/dark/4.png": "2f6a",
	"./home/about/light/1.png": "cec4",
	"./home/about/light/2.png": "1e68",
	"./home/about/light/3.png": "c756",
	"./home/about/light/4.png": "a5aa",
	"./home/ad/ad1.png": "bdb2",
	"./home/ad/ad2.png": "fcf8",
	"./home/ad/ad3.png": "a07b",
	"./home/ad/ad4.png": "9ba6",
	"./home/afa-log-light.png": "d599",
	"./home/afa-logo.png": "1793",
	"./home/app-down.png": "7b5e",
	"./home/articles/left-dark-hover.png": "5206",
	"./home/articles/left-dark.png": "857d1",
	"./home/articles/left-light-hover.png": "8cfb",
	"./home/articles/left-light.png": "86a0",
	"./home/articles/right-dark-hover.png": "4739",
	"./home/articles/right-dark.png": "e641",
	"./home/articles/right-light-hover.png": "f3160",
	"./home/articles/right-light.png": "4635",
	"./home/articles/rightIcon-light.png": "d422",
	"./home/articles/rightIcon.png": "580d",
	"./home/articles/warnIcon-light.png": "a153",
	"./home/articles/warnIcon.png": "3aa8",
	"./home/ata-logo.png": "2dd6",
	"./home/ata-messi.png": "bc48",
	"./home/banner-1.png": "7e8f",
	"./home/banner-2.png": "47ec",
	"./home/banner-3.png": "9fe9",
	"./home/banner-4.png": "2799",
	"./home/banners/1.png": "2d87",
	"./home/banners/2.png": "c788",
	"./home/banners/3.png": "cc0e",
	"./home/banners/4.png": "0e48",
	"./home/banners/bg-dark.png": "838d",
	"./home/banners/bg-light.png": "10d4",
	"./home/banners/bg.png": "e878",
	"./home/banners/champin.png": "4333",
	"./home/banners/gift-light.png": "1077",
	"./home/banners/gift.png": "998d",
	"./home/banners/top-banner-bg.png": "69d8",
	"./home/banners/top-banner.png": "3f92",
	"./home/banners/xieshou-banner-home.png": "032f",
	"./home/banners/xieshou-banner-light.png": "bb42",
	"./home/banners/xieshou-banner.png": "2a50",
	"./home/brandCollect/img/arrow_left.png": "14e8",
	"./home/brandCollect/img/arrow_right.png": "b0e1",
	"./home/brandCollect/img/box1_bg.png": "d9ad",
	"./home/brandCollect/img/box2_bg.png": "7622",
	"./home/brandCollect/img/box2_icon1.png": "1255",
	"./home/brandCollect/img/box2_icon2.png": "b580",
	"./home/brandCollect/img/box2_icon3.png": "b064",
	"./home/brandCollect/img/box2_img1.png": "57b9",
	"./home/brandCollect/img/box2_img11.png": "f72c",
	"./home/brandCollect/img/box2_img2.png": "fade",
	"./home/brandCollect/img/box2_img3.png": "ed13",
	"./home/brandCollect/img/box2_tag1.png": "b9a3",
	"./home/brandCollect/img/box2_tag2.png": "9724",
	"./home/brandCollect/img/box2_tag3.png": "8e00",
	"./home/brandCollect/img/box3_bg.png": "ad57",
	"./home/brandCollect/img/box3_icon1.png": "957b",
	"./home/brandCollect/img/box3_icon2.png": "b592",
	"./home/brandCollect/img/box3_icon3.png": "add3",
	"./home/brandCollect/img/box3_icon4.png": "a68a",
	"./home/brandCollect/img/box3_item_bg1.png": "8088",
	"./home/brandCollect/img/box3_item_bg2.png": "98c8",
	"./home/brandCollect/img/dark_arrow_left.png": "681d",
	"./home/brandCollect/img/dark_arrow_right.png": "b91b",
	"./home/brandCollect/img/dark_box2_bg.png": "f12f",
	"./home/brandCollect/img/dark_box2_icon1.png": "e621",
	"./home/brandCollect/img/dark_box2_icon2.png": "4071",
	"./home/brandCollect/img/dark_box2_icon3.png": "39ce",
	"./home/brandCollect/img/dark_box2_tag1.png": "baf2",
	"./home/brandCollect/img/dark_box2_tag2.png": "018f",
	"./home/brandCollect/img/dark_box2_tag3.png": "6b37",
	"./home/brandCollect/img/dark_box3_bg.png": "1cdc",
	"./home/brandCollect/img/dark_box3_icon1.png": "cbc9",
	"./home/brandCollect/img/dark_box3_icon2.png": "0871",
	"./home/brandCollect/img/dark_box3_icon3.png": "c10e",
	"./home/brandCollect/img/dark_box3_icon4.png": "7455",
	"./home/brandCollect/img/dark_box3_item_bg1.png": "d2be",
	"./home/brandCollect/img/dark_box3_item_bg2.png": "8a84",
	"./home/brandCollect/img/dark_left_item_bg.png": "7286",
	"./home/brandCollect/img/dark_left_tag.png": "66b0",
	"./home/brandCollect/img/dark_right_item_bg.png": "8d52",
	"./home/brandCollect/img/dark_right_tag.png": "e56d",
	"./home/brandCollect/img/dark_top_bg.png": "5b84",
	"./home/brandCollect/img/dark_top_icon1.png": "423a",
	"./home/brandCollect/img/dark_top_icon2.png": "6192",
	"./home/brandCollect/img/left_item_bg.png": "3571",
	"./home/brandCollect/img/left_tag.png": "909c",
	"./home/brandCollect/img/light_top_bg.png": "5c83",
	"./home/brandCollect/img/right_item_bg.png": "4efa",
	"./home/brandCollect/img/right_tag.png": "e801",
	"./home/brandCollect/img/top_banner1.png": "3587",
	"./home/brandCollect/img/top_banner2.png": "8dac",
	"./home/brandCollect/img/top_banner3.png": "920e",
	"./home/brandCollect/img/top_banner4.png": "2d02",
	"./home/brandCollect/img/top_icon1.png": "f67f",
	"./home/brandCollect/img/top_icon2.png": "484f",
	"./home/brandCollect/img/top_tag.png": "b216",
	"./home/chart/t1.png": "6112",
	"./home/chart/t2.png": "ac27",
	"./home/down-btn.png": "e05e",
	"./home/download/01-dark.png": "77bd",
	"./home/download/01-light.png": "268d",
	"./home/download/02-dark.png": "7f05",
	"./home/download/02-light.png": "1f90",
	"./home/download/03-dark.png": "3538",
	"./home/download/03-light.png": "8e37",
	"./home/download/04-dark.png": "e888",
	"./home/download/04-light.png": "d48c",
	"./home/download/05-dark.png": "e459",
	"./home/download/05-light.png": "c29d",
	"./home/download/apk-dark.png": "086c",
	"./home/download/apk.png": "a7b2",
	"./home/download/app-dark.png": "f71e",
	"./home/download/app.png": "2559",
	"./home/download/d1.png": "0a5a",
	"./home/download/d2.png": "20ab",
	"./home/download/d3.png": "139f",
	"./home/download/d4.png": "b3de",
	"./home/download/download-bg.png": "3c47",
	"./home/download/google-dark.png": "a800",
	"./home/download/google.png": "cfab",
	"./home/download/qrcode-dark.png": "ec13",
	"./home/download/qrcode.png": "148b",
	"./home/download/qrcodeBig.png": "c30e",
	"./home/google-down.png": "2dae",
	"./home/home-bg.png": "1e85",
	"./home/honor/icon1-light.png": "f857",
	"./home/honor/icon1.png": "c428",
	"./home/honor/icon2-light.png": "fda0",
	"./home/honor/icon2.png": "f69b",
	"./home/honor/icon3-light.png": "7a54",
	"./home/honor/icon3.png": "d240",
	"./home/honor/top-banner-dark.png": "5d7b",
	"./home/honor/top-banner.png": "4c8a",
	"./home/hot/h1.png": "c129",
	"./home/hot/h2.png": "5f6a",
	"./home/hot/h3.png": "f031",
	"./home/hx-mp4-bg.png": "fb24",
	"./home/index_middle-01@2x.png": "c171",
	"./home/index_middle-02@2x.png": "ee5f",
	"./home/index_middle-03@2x.png": "46fe",
	"./home/left-arrow.png": "fe90",
	"./home/mission/1-light.png": "daee",
	"./home/mission/1.png": "668e",
	"./home/mission/2-light.png": "ac36",
	"./home/mission/2.png": "1332",
	"./home/mission/miss-bg.png": "ad5f",
	"./home/mission/mission1.png": "fbba",
	"./home/mission/mission2.png": "2c32",
	"./home/mission/title-bg-2-dark.png": "cf86",
	"./home/mission/title-bg-2-light.png": "5d5f",
	"./home/no-data-8coin.png": "3362",
	"./home/no_data.png": "0748",
	"./home/red-right.png": "0315",
	"./home/right-arrow.png": "6666",
	"./home/security/dark-01.png": "aa25",
	"./home/security/dark-02.png": "95ad",
	"./home/security/dark-03.png": "26b1",
	"./home/security/light-01.png": "47f7",
	"./home/security/light-02.png": "0834",
	"./home/security/light-03.png": "1a21",
	"./home/theme/dark.png": "8c83",
	"./home/theme/light.png": "cdf1",
	"./home/trade-chart/rightIcon-light.png": "7a410",
	"./home/trade-chart/rightIcon.png": "655f",
	"./home/trade-img-8coin.png": "ba2b",
	"./home/warning-icon-white.png": "9208",
	"./home/warning-icon.png": "7d0d",
	"./home/web-banner.png": "6a56",
	"./idol/afa-light.png": "c9e1",
	"./idol/afa.png": "4876",
	"./idol/banner-dark.png": "8f72",
	"./idol/banner-light.png": "d885",
	"./idol/banner.png": "0d90",
	"./idol/feature/f1-d.png": "5741",
	"./idol/feature/f1.png": "09ac",
	"./idol/feature/f2-d.png": "5ebe",
	"./idol/feature/f2.png": "6952",
	"./idol/feature/f3-d.png": "59aa",
	"./idol/feature/f3.png": "e004",
	"./idol/footer-mask-light.png": "cf0e",
	"./idol/footer-mask.png": "aa8b",
	"./idol/line.png": "9bf28",
	"./idol/lists/icon1.png": "617c",
	"./idol/lists/icon2.png": "5526",
	"./idol/lists/icon3.png": "4570",
	"./idol/lists/icon4.png": "fd78",
	"./ja.png": "4c15",
	"./ko.png": "2b91",
	"./lang/f-ar.png": "cc64",
	"./lang/f-cn.png": "232d",
	"./lang/f-de.png": "e207",
	"./lang/f-en.png": "4519",
	"./lang/f-es.png": "7c36",
	"./lang/f-fr.png": "dc10",
	"./lang/f-hi.png": "da37",
	"./lang/f-hk.png": "3625",
	"./lang/f-id.png": "6bbc",
	"./lang/f-it.png": "79c2",
	"./lang/f-ja.png": "93e5",
	"./lang/f-ko.png": "77f6",
	"./lang/f-pt.png": "16e9",
	"./lang/f-ru.png": "376b",
	"./lang/f-th.png": "7a2d",
	"./lang/f-tl.png": "6afb",
	"./lang/f-tr.png": "ffee",
	"./lang/f-vi.png": "d1c0",
	"./lang/f-zh_CN.png": "a199",
	"./lang/f-zh_HK.png": "a6e5",
	"./language-dark.png": "f977",
	"./language-light.png": "f9ed",
	"./left-a.png": "aa26",
	"./left-arrow-bv.png": "7d63",
	"./left-arrow.png": "abff",
	"./letter-header.png": "ddaa",
	"./letter.png": "15e2",
	"./login/banner.png": "6a3e",
	"./login/close_eye.png": "d538",
	"./login/eye-off.png": "2c99",
	"./login/eye-open.png": "b127",
	"./login/open_eye.png": "a6af",
	"./login_bg.png": "bfbd",
	"./logo_8coin-light.png": "d062",
	"./logo_8coin.png": "df32",
	"./markets/markets-top-bg.png": "71bc",
	"./markets/markt-download-8c.png": "f8de",
	"./markets/markt-download.png": "63a6",
	"./markets/markt-up-8c.png": "580b",
	"./markets/markt-up.png": "cfa4",
	"./markets/下载 (2).png": "6526",
	"./markets/下载 (3).png": "f9d0",
	"./markets/下载 (5).png": "9287",
	"./markets/下载.png": "e227",
	"./mbk.png": "9e82",
	"./mht.png": "a6f6",
	"./mining-pool-bg.png": "3afa",
	"./no_data.png": "32a2",
	"./notice/notice-bg.png": "f06d",
	"./photo-camera.png": "f110",
	"./placeholder.png": "59e0",
	"./profit_loss_share_bg.png": "de6a",
	"./promotev3/closed.png": "5b6e",
	"./promotev3/empty.png": "26fe",
	"./promotev3/frame.png": "d3c5",
	"./qr_code.png": "840a",
	"./quickly-coins/AlchemyPay.png": "e012",
	"./quickly-coins/Moonpay.png": "e1a6",
	"./quickly-coins/Paxful.png": "0fd4",
	"./quickly-coins/Routelay.png": "ffe9",
	"./quickly-coins/Simplex.png": "aeb4",
	"./quickly-coins/Transak.png": "b7bb",
	"./quickly-coins/banxa.png": "adb8",
	"./quickly-coins/ipay.png": "1573",
	"./quickly-coins/itez.png": "3e5a",
	"./quickly-coins/m-choose-a.png": "fd3b",
	"./quickly-coins/m-choose.png": "e4591",
	"./quickly-coins/mastercard.png": "cad3",
	"./quickly-coins/mercuryo_n.png": "ef2a",
	"./quickly-coins/quicklycoins-bg.png": "c8a3",
	"./quickly-coins/scpa.png": "4082",
	"./quickly-coins/visa.png": "d4eb",
	"./quickly-coins/wyre.png": "203c",
	"./rePhoto/2.png": "e4ff",
	"./right-a.png": "617e",
	"./right-arrow-bv.png": "fbe4",
	"./right-arrow.png": "0fe1",
	"./select-icon.png": "62ef",
	"./shareInvite/ci.png": "ed9d",
	"./shareInvite/cl.png": "0ea2",
	"./shareInvite/fb.png": "f002",
	"./shareInvite/si.png": "416e",
	"./shareInvite/tg.png": "91e7",
	"./shareInvite/tt.png": "1630",
	"./shareInvite/wx.png": "7ded",
	"./shili1.png": "bfb8",
	"./siteLogo/8coin.png": "6956",
	"./sprz.png": "e40c",
	"./st-icon-1-1.png": "b435",
	"./st-icon-1.png": "23c4",
	"./st-icon-2-1.png": "245c",
	"./st-icon-2.png": "363a",
	"./st-icon-3-1.png": "5fe5",
	"./st-icon-3.png": "decf",
	"./stock_hk.png": "3b59",
	"./stock_us.png": "4952",
	"./stocks/AAPL.png": "955f",
	"./stocks/AMZN.png": "7783",
	"./stocks/GOOG.png": "1eb5",
	"./stocks/INTC.png": "b16e",
	"./stocks/KO.png": "3b81",
	"./stocks/MSFT.png": "779a",
	"./stocks/NVDA.png": "aa35",
	"./stocks/TSLA.png": "d291",
	"./stocks/TSM.png": "5870",
	"./stocks/meta.png": "d6fa",
	"./success.png": "d284",
	"./table-empty@2x.png": "fa35",
	"./tg.png": "61ce",
	"./token2049/Instagram.png": "b58f",
	"./token2049/Instagram_dark.png": "72c5",
	"./token2049/LinkedIn.png": "9fd2",
	"./token2049/LinkedIn_dark.png": "8c01",
	"./token2049/arrow.png": "5fd4",
	"./token2049/arrow_box1.png": "e7d5",
	"./token2049/arrow_dark.png": "f02a",
	"./token2049/banner1.png": "56925",
	"./token2049/banner2.png": "8c86",
	"./token2049/banner3.png": "dd19",
	"./token2049/banner4.png": "fbe3",
	"./token2049/banner5.png": "64b2",
	"./token2049/banner6.png": "8dbd",
	"./token2049/box1_bg.png": "9fee",
	"./token2049/box1_bg_dark.png": "87bd",
	"./token2049/box1_icon1.png": "598d",
	"./token2049/box1_icon10.png": "6275",
	"./token2049/box1_icon11.png": "e4de",
	"./token2049/box1_icon12.png": "0d93",
	"./token2049/box1_icon2.png": "135e",
	"./token2049/box1_icon3.png": "8ee7",
	"./token2049/box1_icon4.png": "891f",
	"./token2049/box1_icon5.png": "78c5",
	"./token2049/box1_icon6.png": "5eb3",
	"./token2049/box1_icon7.png": "68cf",
	"./token2049/box1_icon8.png": "e67a",
	"./token2049/box1_icon9.png": "b7b9",
	"./token2049/box1_img.png": "7b1f",
	"./token2049/box1_img_dark.png": "b697",
	"./token2049/box1_price_img.png": "0062",
	"./token2049/box1_price_img2.png": "e7b0",
	"./token2049/box1_title.png": "6004",
	"./token2049/box2_bg.png": "a3f5",
	"./token2049/box2_bg_dark.png": "2700",
	"./token2049/box2_icon1.png": "f817",
	"./token2049/box2_icon2.png": "e310",
	"./token2049/box2_icon3 1.png": "281f",
	"./token2049/box2_icon3.png": "4a4d",
	"./token2049/box2_img.png": "2e53",
	"./token2049/box2_img_dark.png": "2572",
	"./token2049/box2_logo.png": "e779",
	"./token2049/box2_logo_dark.png": "92a6",
	"./token2049/box2_renwu.png": "dbd2",
	"./token2049/box2_title.png": "622d",
	"./token2049/box3_active_bg.png": "380d",
	"./token2049/box3_arrow.png": "6f0e",
	"./token2049/box3_arrow_active.png": "27aa",
	"./token2049/box3_img1.png": "0160",
	"./token2049/box3_img1_active.png": "0390",
	"./token2049/box3_img1_active_dark.png": "6a94",
	"./token2049/box3_img1_dark.png": "f888",
	"./token2049/box3_img1_light.png": "dfe5b",
	"./token2049/box3_img2.png": "d938",
	"./token2049/box3_img2_active.png": "30bf",
	"./token2049/box3_img2_active_dark.png": "498f",
	"./token2049/box3_img2_dark.png": "332c",
	"./token2049/box3_img2_light.png": "052f",
	"./token2049/box3_img3.png": "6177",
	"./token2049/box3_img3_active.png": "5833",
	"./token2049/box3_img3_active_dark.png": "0a2e",
	"./token2049/box3_img3_dark.png": "658a",
	"./token2049/box3_img3_light.png": "8e80",
	"./token2049/box3_img4.png": "f316",
	"./token2049/box3_img4_active.png": "dab2",
	"./token2049/box3_img4_active_dark.png": "d8b1",
	"./token2049/box3_img4_dark.png": "65fe",
	"./token2049/box3_img4_light.png": "11df",
	"./token2049/box4_bg_dark.png": "ef0b",
	"./token2049/box4_bg_light.png": "2d05",
	"./token2049/btn_arrow.png": "7ed8",
	"./token2049/btn_arrow_dark.png": "a6c9",
	"./token2049/close_h5.png": "152a",
	"./token2049/discord.png": "aed8",
	"./token2049/discord_dark.png": "2474",
	"./token2049/en-box4-text-dark.png": "3454",
	"./token2049/en-box4-text-light.png": "0a24",
	"./token2049/en-top-bg.png": "3af8",
	"./token2049/es-box4-text-dark.png": "c504",
	"./token2049/es-box4-text-light.png": "644e",
	"./token2049/es-top-bg.png": "1766",
	"./token2049/facebook.png": "70e3",
	"./token2049/first_bg.png": "a398",
	"./token2049/first_bg_dark.png": "c9b0",
	"./token2049/hot.png": "7be0",
	"./token2049/icon1.png": "b3aa",
	"./token2049/icon2.png": "ef4f",
	"./token2049/icon3.png": "0a42",
	"./token2049/left.png": "8087",
	"./token2049/liIcon.png": "77f9",
	"./token2049/li_img.png": "8b17",
	"./token2049/list_img1.png": "4007",
	"./token2049/list_img2.png": "f1a5",
	"./token2049/list_img3.png": "1870",
	"./token2049/logo.png": "209b",
	"./token2049/logo_h5.png": "bf7b",
	"./token2049/m_logo.png": "d991",
	"./token2049/midBox_bg_dark.png": "4122",
	"./token2049/midBox_bg_light.png": "e4cc",
	"./token2049/midBox_img.png": "2aa0",
	"./token2049/midBox_mark.png": "05c7",
	"./token2049/midBox_mark_dark.png": "ece7",
	"./token2049/mixBox_bg.png": "381c",
	"./token2049/mixBox_bg_dark.png": "40b7",
	"./token2049/moon.png": "ba38",
	"./token2049/next.png": "798c",
	"./token2049/nextIcon.png": "eea9",
	"./token2049/nextIcon_dark.png": "5c4c",
	"./token2049/playIcon.png": "6525",
	"./token2049/pre.png": "39a69",
	"./token2049/preIcon.png": "8879",
	"./token2049/preIcon_dark.png": "6ece",
	"./token2049/pt-box4-text-dark.png": "3f7a",
	"./token2049/pt-box4-text-light.png": "630e",
	"./token2049/pt-top-bg.png": "2b39",
	"./token2049/qianming.png": "d2a7",
	"./token2049/qrCode.png": "4789",
	"./token2049/rightText_zh.png": "69d9",
	"./token2049/rule_close.png": "84ab",
	"./token2049/second_img.png": "4123",
	"./token2049/second_img_dark.png": "b7a3",
	"./token2049/star.png": "aaba",
	"./token2049/star_dark.png": "cb77",
	"./token2049/telegram.png": "fd22",
	"./token2049/telegram_dark.png": "e195",
	"./token2049/text/en-box4-text-dark.png": "596d",
	"./token2049/text/en-box4-text-light.png": "d189",
	"./token2049/text/es-box4-text-dark.png": "7a72",
	"./token2049/text/es-box4-text-light.png": "5b20",
	"./token2049/text/pt-box4-text-dark.png": "a860",
	"./token2049/text/pt-box4-text-light.png": "96bc",
	"./token2049/text/th-box4-text-dark.png": "2505",
	"./token2049/text/th-box4-text-light.png": "1350",
	"./token2049/text/vi-box4-text-dark.png": "58e2",
	"./token2049/text/vi-box4-text-light.png": "164b",
	"./token2049/text/zh_CN-box4-text-dark.png": "bec0",
	"./token2049/text/zh_CN-box4-text-light.png": "74f3",
	"./token2049/th-box4-text-dark.png": "eae1",
	"./token2049/th-box4-text-light.png": "797f",
	"./token2049/th-top-bg.png": "d93c",
	"./token2049/ticktok.png": "36f5",
	"./token2049/titleImgPc.png": "2b05",
	"./token2049/title_zh.png": "ad84",
	"./token2049/top_bg.png": "5008",
	"./token2049/top_gold_bg.png": "9de6",
	"./token2049/top_icon1.png": "0a1a",
	"./token2049/top_icon2.png": "8377",
	"./token2049/top_shadow.png": "aa48",
	"./token2049/twitter.png": "d32d",
	"./token2049/twitter_dark.png": "795b",
	"./token2049/vi-box4-text-dark.png": "2b47",
	"./token2049/vi-box4-text-light.png": "2d82",
	"./token2049/vi-top-bg.png": "0e8d",
	"./token2049/youtube.png": "0b4a",
	"./token2049/zalo.png": "b505",
	"./token2049/zalo_dark.png": "a2fe",
	"./token2049/zh_CN-box4-text-dark.png": "8687",
	"./token2049/zh_CN-box4-text-light.png": "77d4",
	"./token2049/zh_CN-top-bg.png": "7467",
	"./tran-to.png": "2eb6",
	"./uld.png": "dbf5",
	"./user-icon.png": "3591",
	"./users/check.png": "145d",
	"./users/email.png": "d423",
	"./users/forget.png": "770b",
	"./users/google.png": "901c",
	"./users/logo.png": "34ef",
	"./users/mobile.png": "14d4",
	"./users/reset-tip.png": "8275",
	"./users/search.png": "9c96",
	"./users/user.png": "22ed",
	"./users/warn.png": "f200",
	"./users/warn2.png": "41d8",
	"./vip-level/vip-0.png": "edd8",
	"./vip-level/vip-1.png": "88e1",
	"./vip-level/vip-2.png": "a935",
	"./world-light.png": "fd25",
	"./world.png": "f6e3",
	"./zh_CN.png": "e0c3",
	"./zh_HK.png": "216f",
	"./zoom-screen.png": "5e4b",
	"./zqsl.png": "a89d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";